<div
  class="file-upload-wrapper"
  [class.success]="uploadSuccess"
  [class.error]="uploadError"
  [class.disabled]="disabled"
  (drop)="onFileDrop($event)"
  (dragover)="onDragOver($event)"
>
  <input
    type="file"
    [accept]="fileType"
    (change)="onFileChange($event)"
    [disabled]="disabled"
    hidden
    #fileInput
  />
  <div class="file-dropper" (click)="!disabled && fileInput.click()">
    @if (!selectedFile) {
      <fa-icon class="upload-icon" [icon]="['fas', 'upload']"></fa-icon>
    }

    @if (!selectedFile) {
      <p>
        {{ "file-upload.label.drag-and-drop-or-click" | translate }}
      </p>
    }

    @if (fileName()) {
      <div>
        @if (selectedFile || filePreview()) {
          <div class="selected-file">
            <p>
              <span class="file-name">{{ fileName() }}</span> ({{ fileSize() }}
              KB)
            </p>
            @if (!disabled) {
              <fa-icon
                class="delete-icon"
                [icon]="['fas', 'trash']"
                (click)="removeImage()"
              ></fa-icon>
            }
          </div>
        }
      </div>
    }

    @if (uploadError) {
      <p class="upload-error">
        Only files of type: {{ fileType }} are allowed.
      </p>
    }
  </div>
</div>
